import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const testimonials = [
  {
    quote: 'Their professionalism is next level. The team is incredibly skilled and genuinely cared about the result.',
    author: 'A devoted guest',
  },
  {
    quote: 'Aure Studio is beyond professional and easily the best salon experience I have ever had.',
    author: 'A first-time visitor, now regular',
  },
  {
    quote: 'I arrived with a picture and left with something better. They design for you, not the photograph.',
    author: 'A bridal client',
  },
]

export default function Voices() {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    if (!ref.current) return

    const ctx = gsap.context(() => {
      const cards = ref.current?.querySelectorAll('.voices__card')
      if (!cards) return

      gsap.fromTo(
        cards,
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: ref.current,
            start: 'top 80%',
            once: true,
          },
        }
      )
    }, ref.current)

    return () => ctx.revert()
  }, [])

  return (
    <section ref={ref} className="voices">
      <div className="voices__header">
        <span className="voices__label">Voices of Our Guests</span>
      </div>
      <div className="voices__grid">
        {testimonials.map((t, i) => (
          <blockquote key={i} className="voices__card">
            <span className="voices__mark">“</span>
            <p className="voices__quote">{t.quote}</p>
            <footer className="voices__author">— {t.author}</footer>
          </blockquote>
        ))}
      </div>
    </section>
  )
}